module.exports = __webpack_public_path__ + "static/media/partner-logo-Azure.2043f797.svg";